import { useTranslation } from 'react-i18next'

import { PaymentMethod } from '~/components/dashboard/invoices/payment/constants/addPaymentDialogV2Constants'

export const usePaymentMethodTranslations = () => {
  const { t } = useTranslation(['Invoices', 'Dialogs', 'Common'])

  return {
    [PaymentMethod.CREDIT_DEBIT]: t(
      'Invoices:PAYMENTS.PAYMENT_INITIALIZATION.CREDIT_DEBIT_TYPE',
    ),
    [PaymentMethod.CARECREDIT]: t('Dialogs:ADD_PAYMENT_DIALOG_V2.CARECREDIT'),
    [PaymentMethod.CASH]: t('Common:PAYMENTS.CASH'),
    [PaymentMethod.CHECK]: t('Common:PAYMENTS.CHECK'),
  }
}

export const usePaymentMethodOptions = () => {
  const translations = usePaymentMethodTranslations()

  return [
    {
      value: PaymentMethod.CREDIT_DEBIT,
      label: translations[PaymentMethod.CREDIT_DEBIT],
      selectable: true,
    },
    {
      value: PaymentMethod.CARECREDIT,
      label: translations[PaymentMethod.CARECREDIT],
      selectable: true,
    },
    {
      value: PaymentMethod.CASH,
      label: translations[PaymentMethod.CASH],
      selectable: true,
    },
    {
      value: PaymentMethod.CHECK,
      label: translations[PaymentMethod.CHECK],
      selectable: true,
    },
  ]
}
